<template>
  <footer class="footer">
    <b-container>
      <b-row>
        <b-col cols="10" md="4" lg="3">
          <div class="logo" style="font-size: 1.1rem"><div style="padding:3px"><a href="."><img src="../assets/logo2.png" /></a></div><a href="."> {{ $t('footer.cityBrand') }}</a></div>
        </b-col>
        <b-col cols="12" md="8" lg="5" offset-lg="0.5">
          <nav class="nav">
            <router-link :to="{ path: '/', hash: '#info' }">{{ $t('header.nav.info') }}</router-link>
            <router-link :to="{ path: '/', hash: '#about' }">{{ $t('header.nav.about') }}</router-link>
            <router-link :to="{ path: '/', hash: '#change' }">{{ $t('header.nav.change') }}</router-link>
            <router-link :to="{ path: '/', hash: '#rates' }">{{ $t('header.nav.rates') }}</router-link>
            <router-link to="/aml-kyc">{{ $t('header.nav.amlKyc') }}</router-link>
          </nav>
        </b-col>
        <b-col cols="12" md="4" offset-md="8" lg="4" offset-lg="0">
          <div class="contacts">
            <div class="wrap">
              <p>{{ $t('header.workingHours') }}</p>
              <p>
                {{ $t('header.weekdays') }}
                {{ $t('header.weekdaysTime') }}
              </p>
              <p>
                {{ $t('header.weekend') }}
                {{ $t('header.weekendTime') }}
              </p>
            </div>
            <div class="wrap">
              <a href="tel:+38 (098) 750 7991" target="_blank">+38 (098) 750 7991</a>
              <a class="icon" href="https://telegram.me/MoneyCashBit" target="_blank">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Bold"
                  enable-background="new 0 0 24 24"
                  height="512px"
                  viewBox="0 0 24 24"
                  width="512px"
                  class
                >
                  <g>
                    <path
                      d="m12 24c6.629 0 12-5.371 12-12s-5.371-12-12-12-12 5.371-12 12 5.371 12 12 12zm-6.509-12.26 11.57-4.461c.537-.194 1.006.131.832.943l.001-.001-1.97 9.281c-.146.658-.537.818-1.084.508l-3-2.211-1.447 1.394c-.16.16-.295.295-.605.295l.213-3.053 5.56-5.023c.242-.213-.054-.333-.373-.121l-6.871 4.326-2.962-.924c-.643-.204-.657-.643.136-.953z"
                      data-original="#000000"
                      class="active-path"
                      data-old_color="#000000"
                      fill="#94A1B2"
                    />
                  </g>
                </svg>
              </a>
              <a class="icon" href="viber://chat?number=+380987507991" target="_blank">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  enable-background="new 0 0 24 24"
                  height="512px"
                  viewBox="0 0 24 24"
                  width="512px"
                >
                  <g>
                    <g fill="#8e24aa">
                      <path
                        d="m23.155 13.893c.716-6.027-.344-9.832-2.256-11.553l.001-.001c-3.086-2.939-13.508-3.374-17.2.132-1.658 1.715-2.242 4.232-2.306 7.348-.064 3.117-.14 8.956 5.301 10.54h.005l-.005 2.419s-.037.98.589 1.177c.716.232 1.04-.223 3.267-2.883 3.724.323 6.584-.417 6.909-.525.752-.252 5.007-.815 5.695-6.654zm-12.237 5.477s-2.357 2.939-3.09 3.702c-.24.248-.503.225-.499-.267 0-.323.018-4.016.018-4.016-4.613-1.322-4.341-6.294-4.291-8.895.05-2.602.526-4.733 1.93-6.168 3.239-3.037 12.376-2.358 14.704-.17 2.846 2.523 1.833 9.651 1.839 9.894-.585 4.874-4.033 5.183-4.667 5.394-.271.09-2.786.737-5.944.526z"
                        data-original="#8E24AA"
                        class="active-path"
                        data-old_color="#8E24AA"
                        fill="#94A1B2"
                      />
                      <path
                        d="m12.222 4.297c-.385 0-.385.6 0 .605 2.987.023 5.447 2.105 5.474 5.924 0 .403.59.398.585-.005h-.001c-.032-4.115-2.718-6.501-6.058-6.524z"
                        data-original="#8E24AA"
                        class="active-path"
                        data-old_color="#8E24AA"
                        fill="#94A1B2"
                      />
                      <path
                        d="m16.151 10.193c-.009.398.58.417.585.014.049-2.269-1.35-4.138-3.979-4.335-.385-.028-.425.577-.041.605 2.28.173 3.481 1.729 3.435 3.716z"
                        data-original="#8E24AA"
                        class="active-path"
                        data-old_color="#8E24AA"
                        fill="#94A1B2"
                      />
                      <path
                        d="m15.521 12.774c-.494-.286-.997-.108-1.205.173l-.435.563c-.221.286-.634.248-.634.248-3.014-.797-3.82-3.951-3.82-3.951s-.037-.427.239-.656l.544-.45c.272-.216.444-.736.167-1.247-.74-1.337-1.237-1.798-1.49-2.152-.266-.333-.666-.408-1.082-.183h-.009c-.865.506-1.812 1.453-1.509 2.428.517 1.028 1.467 4.305 4.495 6.781 1.423 1.171 3.675 2.371 4.631 2.648l.009.014c.942.314 1.858-.67 2.347-1.561v-.007c.217-.431.145-.839-.172-1.106-.562-.548-1.41-1.153-2.076-1.542z"
                        data-original="#8E24AA"
                        class="active-path"
                        data-old_color="#8E24AA"
                        fill="#94A1B2"
                      />
                      <path
                        d="m13.169 8.104c.961.056 1.427.558 1.477 1.589.018.403.603.375.585-.028-.064-1.346-.766-2.096-2.03-2.166-.385-.023-.421.582-.032.605z"
                        data-original="#8E24AA"
                        class="active-path"
                        data-old_color="#8E24AA"
                        fill="#94A1B2"
                      />
                    </g>
                  </g>
                </svg>
              </a>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row style="padding-top:2rem">
    <b-col cols="12" md="12" lg="12">
    <div align="center">
    <p>{{ $t('footer.copyright') }}</p>
    <p>{{ $t('footer.disclaimer') }}
    </p>
    </div>
    </b-col>
    </b-row>
    </b-container>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="sass">
@use '../styles/main'

.footer
  .container
    padding-top: 30px
    padding-bottom: 30px
    border-top-left-radius: 5px
    border-top-right-radius: 5px
    background-color: main.$elements-bg
    box-shadow: 0px 0px 10px rgba(22, 22, 26, .5)
  .logo
    width: 100%
    height: 100%
    display: flex
    align-items: center
    p
      margin: 0
  .contacts
    display: flex
    flex-direction: column
    .wrap
      width: 100%
      text-align: right
      a
        margin-left: 10px
      p
        margin-bottom: .25rem

@media screen and (max-width: 768px)
  .footer
    .logo
      justify-content: center
      margin-bottom: 1rem
    .nav
      flex-direction: column
      a
        margin-bottom: .5rem
    .contacts
      .wrap
        text-align: center
        a
          margin-right: 10px

@media screen and (max-width: 576px)
  .container
    border-top-left-radius: 0
    border-top-right-radius: 0
</style>